import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/icons-material/FormatBold": FormatBoldIcon, "@mui/icons-material/FormatItalic": FormatItalicIcon, "@mui/material/Box": Box, "@mui/material/Divider": Divider } } });
export default ClientProvider;
